import getChartConfigTemplate from "../Templates/BarOrColumnChart/utils";

const getChartConfig = function(data, options={}) {
  return getChartConfigTemplate({data: data, showPreviousPeriodDataLabels: false, exportFileName: options.exportFileName})
}

export default getChartConfig;
